import './_reporter'

// external modules
import React, { Suspense, useLayoutEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import FontFaceObserver from 'fontfaceobserver'
import { HelmetProvider } from 'react-helmet-async'

// internal modules
import './Common/AntdStyles/antd.less'
import './Common/Theme/Fonts/fontLoader.less'

import { store } from './RootRedux'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './index.less'
import i18n from './i18n'
import App from './App'
import { I18nextProvider } from 'react-i18next'

// =============== Pre load ===============
const LoadApp = (props) => {
  // State
  // ------------------
  const [Loaded, setLoaded] = useState(false)

  // Effects
  // ------------------
  useLayoutEffect(() => {
    ;(async () => {
      const promises = []
      promises.push(loadFontAsync('Open Sans'))
      promises.push(loadFontAsync('Open Sans SemiBold'))
      promises.push(loadFontAsync('Shopee_font Bold'))
      promises.push(loadFontAsync('Shopee_font Medium'))
      promises.push(loadFontAsync('Shopee_font'))
      promises.push(loadFontAsync('Roboto Bold'))
      promises.push(loadFontAsync('Roboto Medium'))
      promises.push(loadFontAsync('Roboto Regular'))
      await Promise.allSettled(promises)
      setLoaded(true)
    })()
  }, [])

  // Method
  // ------------------
  const loadFontAsync = (fontFamily) =>
    new Promise((res, rej) => {
      const font = new FontFaceObserver(fontFamily)
      font.load().then(res).catch(rej)
    })
  return Loaded ? props.children : null
}

const rootElement = document.getElementById('root')

// Use hydrate if the app has been prerendered, otherwise use render
const renderMethod = rootElement.hasChildNodes()
  ? ReactDOM.hydrate
  : ReactDOM.render

renderMethod(
  <LoadApp>
    <React.StrictMode>
      <HelmetProvider>
        <Provider store={store}>
          <I18nextProvider i18n={i18n}>
            <Suspense fallback={<div />}>
              <Router>
                <App />
              </Router>
            </Suspense>
          </I18nextProvider>
        </Provider>
      </HelmetProvider>
    </React.StrictMode>
  </LoadApp>,
  rootElement
)
